import React, { useEffect } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { linkedinAPI } from '../services/api';

export default function LinkedInOAuthCallback() {
  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');
      const errorDescription = params.get('error_description');

      const notifyError = (errorMsg) => {
        if (window.opener) {
          window.opener.postMessage(
            { type: 'linkedin_error', error: errorMsg },
            window.location.origin
          );
          window.close();
        } else {
          window.location.href = '/clients';
        }
      };

      if (error) {
        notifyError(errorDescription || error);
        return;
      }

      if (!code) {
        notifyError('No authorization code received');
        return;
      }

      if (!state) {
        notifyError(
          'Missing OAuth state. Close this window and connect LinkedIn again from the app.'
        );
        return;
      }

      try {
        await linkedinAPI.exchangeLinkedInCode(code, state);
        if (window.opener) {
          window.opener.postMessage(
            { type: 'linkedin_connected' },
            window.location.origin
          );
          window.close();
        } else {
          window.location.href = '/clients';
        }
      } catch (err) {
        console.error('LinkedIn OAuth error:', err);
        notifyError(err.message || 'LinkedIn connection failed');
      }
    };

    handleCallback();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#0d1117',
        color: '#f0f6fc',
      }}
    >
      <CircularProgress sx={{ mb: 2, color: '#0a66c2' }} />
      <Typography variant="h6" sx={{ textAlign: 'center' }}>
        Connecting to LinkedIn...
      </Typography>
      <Typography
        variant="body2"
        sx={{ textAlign: 'center', mt: 1, color: '#7d8590' }}
      >
        Please wait while we complete the connection.
      </Typography>
    </Box>
  );
}
